import { createSlice } from "@reduxjs/toolkit";
import { fetchPackingList, savePacking, deletePacking } from "./packingThunks";

const initialState = {
  packDetails: [],
  loadingList: false,
  loadingSave: false,
  error: null,
  successMessage: null,
  isEditPacking: false,
  selectedPacking: null,
};

const packingSlice = createSlice({
  name: "packing",
  initialState,
  reducers: {
    clearMessages: (state) => {
      state.error = null;
      state.successMessage = null;
    },
    setIsEditPacking: (state, action) => {
      state.isEditPacking = action.payload;
    },
    setSelectedPacking: (state, action) => {
      state.selectedPacking = action.payload;
    },
    resetPackingState: (state) => {
      state.isEditPacking = false;
      state.selectedPacking = null;
      state.error = null;
      state.successMessage = null;
      state.loadingSave = false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchPackingList.pending, (state) => {
        state.loadingList = true;
      })
      .addCase(fetchPackingList.fulfilled, (state, action) => {
        state.loadingList = false;
        state.packDetails = action.payload;
      })
      .addCase(fetchPackingList.rejected, (state, action) => {
        state.loadingList = false;
        state.error = action.payload;
      })
      .addCase(savePacking.pending, (state) => {
        state.loadingSave = true;
      })
      .addCase(savePacking.fulfilled, (state, action) => {
        state.loadingSave = false;
        state.successMessage = action.payload;
      })
      .addCase(savePacking.rejected, (state, action) => {
        state.loadingSave = false;
        state.error = action.payload;
      })
      .addCase(deletePacking.fulfilled, (state, action) => {
        state.successMessage = action.payload;
      })
      .addCase(deletePacking.rejected, (state, action) => {
        state.error = action.payload;
      });
  },
});

export const {
  clearMessages,
  setIsEditPacking,
  setSelectedPacking,
  resetPackingState,
} = packingSlice.actions;

export default packingSlice.reducer;
